import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Syntax Highlighting"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h1 {...{
      "id": "syntax-highlighting"
    }}>{`Syntax Highlighting`}</h1>
    <p>{`To support syntax highlighting libraries like `}<a parentName="p" {...{
        "href": "https://github.com/PrismJS/prism"
      }}>{`Prism.js`}</a>{`, colors and other
styles can be added to `}<inlineCode parentName="p">{`theme.styles.pre`}</inlineCode>{` to target child elements with class
selectors. Prism.js adds `}<inlineCode parentName="p">{`<span>`}</inlineCode>{` elements with class names that can be used as
child selectors.`}</p>
    <p>{`Install the Theme UI Prism component.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-sh"
      }}>{`npm i @theme-ui/prism
`}</code></pre>
    <p>{`Next, add the Prism component to your MDX components list. If you’re using
Gatsby and `}<inlineCode parentName="p">{`gatsby-plugin-theme-ui`}</inlineCode>{`, this file is
`}<inlineCode parentName="p">{`src/gatsby-plugin-theme-ui/components.js`}</inlineCode>{`.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "filename=components.js",
        "filename": "components.js"
      }}>{`import Prism from '@theme-ui/prism'

const components = {
  pre: ({ children }) => <>{children}</>,
  code: Prism,
}

export default components
`}</code></pre>
    <p>{`In your theme, import and add a syntax theme from the Prism package.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js",
        "metastring": "filename=src/gatsby-plugin-theme-ui/index.js",
        "filename": "src/gatsby-plugin-theme-ui/index.js"
      }}>{`import nightOwl from '@theme-ui/prism/presets/night-owl'

const theme = {
  styles: {
    pre: {
      ...nightOwl,
    },
  },
}

export default theme
`}</code></pre>
    <p>{`You can also construct your own syntax theme inline, using theme colors:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`{
  colors: {
    red: '#ec3750',
    green: '#33d6a6',
    blue: '#338eda',
    gray: '#666',
  },
  styles: {
    pre: {
      '.comment, .prolog, .doctype, .cdata, .punctuation, .operator, .entity, .url': {
        // theme.colors and other values can be referenced
        color: 'gray'
      },
      '.property, .tag, .boolean, .number, .constant, .symbol, .deleted, .function, .class-name, .regex, .important, .variable':
        {
          color: 'red'
        },
      '.atrule, .attr-value, .keyword': {
        color: 'blue'
      },
      '.selector, .attr-name, .string, .char, .builtin, .inserted': {
        color: 'green'
      }
    }
  }
}
}
`}</code></pre>
    <p>{`For more details, check out the `}<a parentName="p" {...{
        "href": "/packages/prism"
      }}>{`Prism package docs`}</a>{`.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      